module.exports = {
  notIssued: 'Chưa phát hành',
  getBack: 'Đã thu hồi',
  receive: 'Đã tiếp nhận',
  toClaim: 'Đã nhận',
  issuance: 'Đã phát hành',
  changeSingle: 'Đang sửa đơn',
  lineCreditDialog: {
    title: 'Thông báo',
    businessNumber: 'Mã nghiệp vụ:',
    mblNo: 'MBL SỐ:',
    hblNo: 'HBL SỐ:',
    partners: 'Đối tác:',
    lines: 'Hạn mức tín dụng: Đã vượt quá, {0} đồng',
    paymentDays: 'Kỳ hạn tín dụng: {0}',
    unableSave: 'Không thể sử dụng "Đơn tự xuất của khách hàng", vui lòng thanh toán kịp thời.',
    cantUse: 'Hiện không thể lưu tùy chọn đánh dấu trường đơn tự xuất của khách hàng.',
    triggerRemind: 'Hệ thống đã kích hoạt nhắc nhở, vui lòng thanh toán kịp thời.',
    through: 'Quy tắc phát đơn đã được phê duyệt',
    continueOrders: 'Xác nhận có tiếp tục phát đơn không?',
    confirm: 'Xác nhận',
    cancel: 'Đóng'
  }
}
